(function(){
  function isCampusDestination(){return document.body&&document.body.classList.contains('legacy-campus-destination-page')}
  function school(){
    var select=document.getElementById('LegacyCampusBaseSchool');
    if(!select||select.dataset.legacyCampusBaseBound==='1')return;
    select.dataset.legacyCampusBaseBound='1';
    select.addEventListener('change',function(){
      location.assign(select.value?'/collections/campus-collection/'+encodeURIComponent(select.value):'/collections/campus-collection');
    });
  }
  function filter(){
    var button=document.getElementById('LegacyCampusBaseFilter');
    if(!button||button.dataset.legacyCampusBaseBound==='1')return;
    button.dataset.legacyCampusBaseBound='1';
    button.addEventListener('click',function(){
      var form=document.getElementById('FacetFiltersFormMobile');
      var details=form&&(form.closest('details.mobile-facets__disclosure')||form.closest('details'));
      var summary=details&&details.querySelector(':scope > summary');
      if(summary){summary.click();return}
      var fallback=document.querySelector('.mobile-facets__open-wrapper summary,.mobile-facets__disclosure > summary');
      if(fallback)fallback.click();
    });
  }
  function cleanVisibleLegacy(){
    if(!isCampusDestination())return;
    document.querySelectorAll('.legacy-campus-quick-filters').forEach(function(el){el.setAttribute('aria-hidden','true')});
  }
  function run(){if(!isCampusDestination())return;school();filter();cleanVisibleLegacy()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  window.addEventListener('pageshow',run);
  document.addEventListener('shopify:section:load',run);
})();
